import { toastError, toastSuccess } from 'partial/components/react-geek-toast';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  getSubscriptions,
  showSubscription,
  updateSubscription,
} from './actions';

export const usePlansList = (filter) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-subscriptions-list', filter],
    queryFn: getSubscriptions,
    retry: false,
    keepPreviousData: true,
  });
  const data = raw?.data?.data;
  const meta = raw?.data?.meta;
  return [isLoading, data, meta];
};

export const useShowPlan = (id) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['show-subscription', id],
    queryFn: showSubscription,
    retry: false,
    keepPreviousData: true,
    enabled: !!id,
  });
  const data = raw?.data?.data;
  return [isLoading, data];
};

export const useUpdatePlan = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(updateSubscription, {
    onSuccess: () => {
      queryClient.invalidateQueries('show-subscription');
      queryClient.invalidateQueries('get-subscriptions-list');

      toastSuccess('Successfully updated plan!');
      if (typeof onSuccess === 'function') onSuccess();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};
